import { useSelector } from "react-redux"
import { useTranslation } from "react-i18next"

import ModalService from "src/modals"
import { races, raceUnits } from "src/assets/images"
import { selectGameConfig } from "src/store/common"
import { zoneNames } from "src/utils/battlefield"
import { describeBonus, raceNames, specialUnitFor, unitName } from "src/utils/races"

import "./ClassChip.css"

/* A seat's class, as a chip: the plate of the unit only that class fields, small, and its name
   (owner, 2026-10-09). The lobby's seat rows draw it.

   Pressed, it opens the class helper (owner, 2026-09-10: "if pressed, the helper of the class
   appears"): the showcase of that unit — its name, role and ability — with the class in the kicker
   and what the class does as the lines. It is the screen the shop's cards open, so there is one
   answer to "what is a Technologist" and not two that can drift. What a class does comes from the
   server config the simulator applies (`RACE_BONUSES`, `valid_units_per_race`). */
const ClassChip = ({ race, team, className = "" }) => {
  const { t } = useTranslation()
  const gameConfig = useSelector(selectGameConfig)
  if (!race) return null

  const name = raceNames[race] || race
  const openClassHelp = () => {
    const unitsPerRace = gameConfig?.valid_units_per_race || {}
    const unit = specialUnitFor(race, team, unitsPerRace) || raceUnits[race]
    const unitStats = gameConfig?.[`${team}_config`]?.TROOPS?.[unit]
    const bonuses = Object.entries(gameConfig?.rules_config?.RACE_BONUSES?.[race] || {})
    ModalService.show("ArtShowcaseModal", {
      src: races[race],
      title: unit ? unitName(unit) : name,
      kicker: `${name} · ${t(`game.battle.${team}`)}`,
      subtitle: unitStats ? zoneNames(t, gameConfig, team, unit) : undefined,
      lines: [
        unit ? t(`game.units.abilities.${unit}`, { defaultValue: "" }) : "",
        ...(bonuses.length ? bonuses.map(([key, value]) => describeBonus(key, value, team)) : [t("shop.noBonuses")]),
      ],
      team,
    })
  }

  return (
    <button type="button" className={`class-chip ${className}`.trim()} onClick={openClassHelp} title={name}>
      <img src={races[race]} alt="" className="class-chip-art" />
      <span className="class-chip-name">{name}</span>
    </button>
  )
}

export default ClassChip
